import { useQuery } from "@tanstack/react-query";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { brl, fmtDate, pct } from "@/lib/format";
import { Badge, EmptyState, ErrorState, Loading, Page, PageHeader } from "@/components/kit";

export default function Suppliers() {
  const { data, isLoading, isError, error, refetch } = useQuery({ queryKey: ["suppliers"], queryFn: () => api("/reports/suppliers") });
  return (
    <Page>
      <PageHeader title="Ranking de fornecedores" back subtitle="Preço médio por produto em todas as notas com itens lançadas. O primeiro é o mais barato." />
      {isLoading ? <Loading /> : isError ? <ErrorState message={error.message} onRetry={refetch} /> : !data.length ? (
        <EmptyState title="Sem dados ainda" text="Lance notas fiscais com itens para comparar os preços dos fornecedores." />
      ) : (
        <div className="grid md:grid-cols-2 gap-4" data-testid="suppliers-list">
          {data.map((p) => (
            <div key={p.product_id} className="card" data-testid={`supplier-product-${p.product_id}`}>
              <div className="flex items-center gap-3 mb-3">
                <span className="h3 flex-1 truncate">{p.product_name}</span>
                {p.saving_pct > 0 && <Badge tone="success">até {pct(p.saving_pct, 0)} mais barato</Badge>}
              </div>
              <div className="flex flex-col gap-2">
                {p.suppliers.map((s, i) => (
                  <div key={s.supplier} className="flex items-center gap-3" data-testid={`supplier-row-${p.product_id}-${i}`}>
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold" style={{ background: i === 0 ? "var(--brand)" : "var(--surface-alt)", color: i === 0 ? "#fff" : "var(--muted)" }}>
                      {i === 0 ? <Trophy size={14} /> : i + 1}
                    </div>
                    <div className="flex-1 min-w-0"><div className="label truncate">{s.supplier}</div><div className="caption">{s.count} nota(s) · última {fmtDate(s.last_date)}</div></div>
                    <div className="text-right"><div className="label tnum">{brl(s.avg)}/{p.unit}</div><div className="caption tnum">mín. {brl(s.min)}</div></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </Page>
  );
}
